import {IApiResponse, IHttpService} from "../http-service";
import {rootContainer, TYPE} from "../container/root";
import {injectable} from "inversify";
import { IWalletBalanceAmendmentRequest } from "../../pages/admins/manage-merchants-plans/stores/manage-merchant-wallet-store";

export interface IAdminMerchantWallet {
    id: number;
    amount: number;
    currency: string;
}

@injectable()
class AdminManageMerchantWalletService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async fetchMerchantWallet(shopId: number): Promise<IAdminMerchantWallet | null> {
        const res = await this.httpService.get<IApiResponse<IAdminMerchantWallet | null>>(`/rms-api/admin-wallet/${shopId}`);
        return res.payload;
    }

    async saveBalanceAmendment(shopId: number, data: IWalletBalanceAmendmentRequest): Promise<IAdminMerchantWallet> {
        const res = await this.httpService.post<IApiResponse<IAdminMerchantWallet>>(`/rms-api/admin-wallet-balance/${shopId}`, { ...data });
        return res.payload;
    }
}

export default AdminManageMerchantWalletService;